import React, { Fragment } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { withWidth } from "@material-ui/core";

const Gstin = (props: any) => {
  let { width } = props;
  let mobileViews = ["xs", "sm"];
  const mobileView = mobileViews.includes(width);
  return (
    <Fragment>
      <section id="contact" className="contact_us">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-sm-6 col-xs-12">
              <div className="section-title wow fadeInUp" data-wow-delay="0.1s">
                <h2>Company Details</h2>
              </div>
              <div className="space">
                <h5>
                  {" "}
                  <b> Company Name -</b> Kabra Express Logistics Private Limited
                </h5>
              </div>
              <div className="space">
                <b>Company Address- </b>
                02/13 Vallabh Flats, Vijay Chowk, NR Sardar Patel Diamond
                Market, Bapunagar, Ahmedabad, Gujarat 380024
              </div>
              <div className="space">
                <p>
                  <i className="fa fa-envelope-o fa-fw pull-left fa-2x"></i>
                  <a href="mailto: info@kabraexpress.com">
                    info@kabraexpress.com
                  </a>
                </p>
              </div>
              <div className="space">
                <p>
                  <i className="fa fa-phone fa-fw pull-left fa-2x"></i>
                  <a href="tel:+917575857777">+917575857777</a> <br />{" "}
                  <a href="tel:+919099982886">+91 9099982886</a>
                </p>
              </div>
              <div className="space">
                <p>
                  {" "}
                  <b> PAN card details -</b> AAGCK6871L
                </p>
              </div>
            </div>
            <div
              className="col-md-6 col-sm-6 col-xs-12 section-title wow fadeInUp "
              data-wow-delay="0.1s"
            >
              <h2>GST</h2>

              <div style={{ overflowX: mobileView ? "auto" : undefined }}>
                {/* <TableContainer component={Paper}> */}
                <Table
                  aria-label="simple table"
                  style={{
                    marginLeft: !mobileView ? "20px" : "",
                    border: "1px solid lightgrey",
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        {" "}
                        <strong style={{ fontSize: "17px" }}>
                          {" "}
                          State
                        </strong>{" "}
                      </TableCell>
                      <TableCell>
                        {" "}
                        <strong style={{ fontSize: "17px" }}>
                          {" "}
                          Headoffice
                        </strong>{" "}
                      </TableCell>
                      <TableCell>
                        {" "}
                        <strong style={{ fontSize: "17px" }}>
                          {" "}
                          GSTIN
                        </strong>{" "}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        <b style={{ fontSize: "15px" }}> Gujarat </b>
                      </TableCell>
                      <TableCell>
                        {" "}
                        <b style={{ fontSize: "15px" }}> Bapunagar </b>
                      </TableCell>
                      <TableCell>
                        {" "}
                        <b style={{ fontSize: "15px" }}>
                          {" "}
                          24AAGCK6871L1Z2{" "}
                        </b>{" "}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        <b style={{ fontSize: "15px" }}> Maharashtra </b>
                      </TableCell>
                      <TableCell>
                        {" "}
                        <b style={{ fontSize: "15px" }}> Aurangabad </b>{" "}
                      </TableCell>
                      <TableCell>
                        {" "}
                        <b style={{ fontSize: "15px" }}>
                          {" "}
                          27AAGCK6871L1ZW{" "}
                        </b>{" "}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        <b style={{ fontSize: "15px" }}> Madhya Pradesh </b>
                      </TableCell>
                      <TableCell>
                        {" "}
                        <b style={{ fontSize: "15px" }}> Indore </b>{" "}
                      </TableCell>
                      <TableCell>
                        {" "}
                        <b style={{ fontSize: "15px" }}> 23AAGCK6871L1Z4 </b>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
                {/* </TableContainer> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <br />
      <br />
      <br />
    </Fragment>
  );
};

export default withWidth()(Gstin);
